import { IUrlMenuItem, MenuItemType } from "web/types/Menu";

import { ProcessedMenuItem } from "./types";

const handleUrlMenuItem = (
  menuItem: IUrlMenuItem,
  isEn: boolean
): ProcessedMenuItem | null => {
  return {
    type: MenuItemType.URL,
    code: menuItem.code,
    title: menuItem.title,
    url: isEn ? menuItem.url_en : menuItem.url,
  };
};

export default handleUrlMenuItem;
